/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PhoneCallStepCallScriptDoc } from './phoneCallStepCallScriptDoc';
import type { PhoneCallStepPriority } from './phoneCallStepPriority';
import type { PhoneCallStepTaskNoteDoc } from './phoneCallStepTaskNoteDoc';
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';

export interface PhoneCallStep {
  schedule: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay;
  priority?: PhoneCallStepPriority;
  type: 'phone_call';
  call_script_doc?: PhoneCallStepCallScriptDoc;
  task_note_doc?: PhoneCallStepTaskNoteDoc;
}
